import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ADMIN_AUTH_CHANGE_EVENT, ensureAdminSession, readAdminSession } from './adminSession';

// 관리자 세션이 없으면 재발급을 시도하고, 실패하거나 도중에 세션이 지워지면 관리자 로그인 화면으로 돌려보낸다.
export default function RequireAdmin({ children }) {
    const location = useLocation();
    const [status, setStatus] = useState(() => (readAdminSession() ? 'allowed' : 'checking'));

    useEffect(() => {
        if (status !== 'checking') return undefined;
        let active = true;
        ensureAdminSession().then(session => { if (active) setStatus(session ? 'allowed' : 'denied'); });
        return () => { active = false; };
    }, [status]);

    // API 호출 중 재발급까지 실패해 세션이 지워지면 로그인 화면으로 보낸다.
    useEffect(() => {
        const handleAuthChange = () => { if (!readAdminSession()) setStatus('denied'); };
        window.addEventListener(ADMIN_AUTH_CHANGE_EVENT, handleAuthChange);
        return () => window.removeEventListener(ADMIN_AUTH_CHANGE_EVENT, handleAuthChange);
    }, []);

    if (status === 'checking') return <p role="status" style={{ padding: '48px 16px', textAlign: 'center' }}>로그인 정보를 확인하고 있습니다.</p>;
    if (status === 'denied') return <Navigate to="/admin/login" replace state={{ from: location }} />;
    return children;
}

RequireAdmin.propTypes = {
    children: PropTypes.node.isRequired,
};
